<!--
* UI Name: Process Search
* Modify Date: 2021.12.22
-->
<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{ $t("lbl.admin.monitor_header") }}</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row class="custom-form-control custom-figma-1 pb-20">
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pt-0 mt-0 pr-2 pb-2 fixed-height-comp"
            cols="6"
            lg="6"
            md="6"
          >
            <RecentFailed @select-ok="changeProcessDetail($event)" />
          </v-col>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0 pl-2 pb-2 fixed-height-comp"
            cols="6"
            lg="6"
            md="6"
          >
            <processDetail
              :processId="processId"
              :groupId="groupId"
              @select-ok="openMonitoringDataInfoFileViewWindow($event)"
            />
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0 pr-2 pt-2 fixed-height-comp"
            cols="6"
            lg="6"
            md="6"
          >
            <RecentSystemErrors />
          </v-col>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0 pl-2 pt-2 fixed-height-comp"
            cols="6"
            lg="6"
            md="6"
          >
            <RecentTransaction />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <monitoringDataInfoFileViewWindow
        v-if="dialog.type == 'monitoringDataInfoFileViewWindow'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :dataInfo="tempDataInfo"
      ></monitoringDataInfoFileViewWindow>
    </div>
  </div>
</template>

<script>
import processDetail from "@/vue-caas/views/admin/ProcessSearchDetail.vue";
import monitoringDataInfoFileViewWindow from "@/vue-caas/views/monitoring/MonitoringDataInfoFileView.vue";
import RecentFailed from "@/vue-caas/views/admin/RecentFailedTransactions.vue";
import RecentTransaction from "@/vue-caas/views/admin/RecentTransaction.vue";
import RecentSystemErrors from "@/vue-caas/views/admin/RecentSystemErrors.vue";

export default {
  components: {
    processDetail,
    monitoringDataInfoFileViewWindow,
    RecentTransaction,
    RecentFailed,
    RecentSystemErrors,
  },
  data() {
    return {
      dialogs: [],
      dialogId: 1,
      dialog: false,
      arrLayoutDialog: [],
      tempDataInfo: [],
      processId: "",
      groupId: "",
    };
  },
  watch: {},
  created() {},
  methods: {
    changeProcessDetail(rowItem) {
      this.processId = rowItem.processId;
      this.groupId = rowItem.groupId;
    },
    openMonitoringDataInfoFileViewWindow(rowItem) {
      let type = "monitoringDataInfoFileViewWindow";
      this.tempDataInfo = rowItem;

      let item = {
        ROWID: 0,
        data: rowItem,
      };
      let indexArrDialog = this.findDialog(
        "monitoringDataInfoFileViewWindow_0"
      );
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = "Dialog " + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, "left", obj.left);
      this.$set(this.dialogs[index].options, "top", obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
  },
};
</script>

<style>
.fixed-height-comp {
  /* max-height: 1000px;
  min-height: 1000px; */
  height: 600px;
}
.fixed-height-comp .custom-figma-1 .btn-width-1.btn-search.primary {
  width: 83px !important;
}
</style>